// const { createMockGenerator } = require("../utils/mockData")

const img = x => `products/${x}`

// const generateMockProducts = createMockGenerator(index => ({
//   id: index,
//   image: "products/sic-30",
//   name: `Super Life SIC 30`,
//   description: `A breakthrough health and youth preservation system, based on highly innovative and award winning plant stem cell science Phytocelltec Malus Domestica, clinic proven to rejuvenate and revitalize epidermal stem cells and tissues regeneration for a healthier, stronger and younger looking you.`,
//   price: 40000,
// }))

const products = [
  {
    id: "STC-030",
    image: img("stc-30"),
    name: "SuperLife Total Care 30 (STC30)",
    description:
      "STC30 is a breakthrough health and youth preservation system, based on highly innovative and award winning plant stem cell science -Phytocelltec Malus Domestica, clinic proven to rejuvenate and revitalize epidermal stem cells and tissues regeneration - for a healthier, stronger and younger looking you.",
    benefits: [
      "Anti-oxidants",
      "Skin Renewing",
      "Improve Vision",
      "Combat Chronological Aging",
      "Boost Immune System",
    ],
    price: 80,
  },
  {
    id: "SIC-100",
    image: img("sic"),
    name: "SuperLife Imunne Care (SIC)",
    description:
      "SIC is a proprietary blend of nature's extraordinary ingredients powered with AFA Concentrate and Co-Q10. Our advanced formula associated with stamina and logevity is documented to support the natural release of adult stem cells from bone marrow and increase number of circulating stem cells.",
    benefits: [
      "Rich Antioxidant",
      "Strengthens Immune System",
      "Boosts Energy Level",
      "Prevents Biochemical Imbalance",
      "Improves Gut Health",
      "Supports Liver Detoxification",
      "Normalizes Blood Sugar Levels",
    ],
    price: 80,
  },
  {
    id: "SCC-015",
    image: img("scc-15"),
    name: "SuperLife Colon Care 15 (SCC15)",
    description:
      "SCC15 is a rich concotion of nature's very best ingredients to maintain a healthy colon and digestive system. The powerful formula helps to cleanse harmful toxins and impruties and provides  the body with essential nutrients to ensure optimal health.",
    benefits: [
      "Purifies Blood",
      "Maintains Healthy Colon",
      "Improves Digestive Health",
      "Supports Liver Detoxification",
      "Regulates Blood Glucose Levels",
    ],
    price: 80,
  },
  {
    id: "SNC-100",
    image: img("snc"),
    name: "SuperLife Neuron Care (SNC)",
    description:
      "SNC is a powerful concotion of Lutein and Gingko Biloba which helps to rejuvenate and revitalise vision and cognitive functions which deteriorates naturally with age",
    benefits: [
      "Enhances Vision",
      "Improves Memory",
      "Helps Blood Circulation",
      "Aids Cognitive Function",
      "Supports Brain Development",
    ],
    price: 80,
  },
]

exports.__esModule = true
exports.products = products
